import React, { Component } from 'react'
import ClassRemarksPV from './ClassRemarksPV'
import AuthA from '../../store/actions/AuthA'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import {connect} from 'react-redux'

const _ = {
    sortBy: sortBy,
    find: find
}


class ClassRemarksPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classRemarks: [],
      section: [],
      sectionId: '',
      column: null,
      direction: null,
      sectionStudents: [],
      fileName: '',
      classConductSheet: null,
      quarter: 1,
      modalOpen: false,
      sectionSubjects: [],
      sectionStudentId: '',
      open: false,
      remarks1: '',
      remarks2: '',
      remarks3: '',
      remarks4: '',
      created: [],
      checked: [],
      reviewed: [],
      sections: []
    };
    this.getClassRemark = this.getClassRemark.bind(this);
    this.getSectionStudents = this.getSectionStudents.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleUpdateSectionDetails = this.handleUpdateSectionDetails.bind(this);
  }

  getClassRemark(sectionId, sectionStudentId) {
    axios.get(process.env.REACT_APP_URL+'/classRemarks?filter[where][active]=true&filter[where][sectionId]='+sectionId+'&filter[where][sectionStudentId]='+sectionStudentId)
    .then(response => {
      this.setState({ classRemarks: response.data}, () => {
        if (response.data.length !== 0) {
          this.setState({
            remarks1: response.data[0].firstQuarter,
            remarks2: response.data[0].secondQuarter,
            remarks3: response.data[0].thirdQuarter,
            remarks4: response.data[0].fourthQuarter,
          })
        } else {
          this.setState({
            remarks1: '',
            remarks2: '',
            remarks3: '',
            remarks4: '',
          })
        }
      });
    })
    .catch(err => alert(err));
  }

  getSection = (sectionId) => {
    axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true&filter[include]=details&filter[where][sectionId]='+sectionId)
    .then(async(response) => {
      await this.getSectionDetailsForChecking();
      await this.getSectionDetailsForReview();
      await this.getSectionDetailsForApproval();
      await this.getSections();
      this.setState({ section: response.data});
    });
  }

  getSectionDetailsForChecking = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Created&filter[where][type]=remark&filter[where][quarter]=${this.state.quarter}`)
    .then(response => {
      this.setState({created: response.data})
    });
  }

  getSectionDetailsForReview = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Checked&filter[where][type]=remark&filter[where][quarter]=${this.state.quarter}`)
    .then(response => {
      this.setState({checked: response.data})
    });
  }

  getSectionDetailsForApproval = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionDetails?filter[where][active]=true&filter[include]=section&filter[where][status]=Reviewed&filter[where][type]=remark&filter[where][quarter]=${this.state.quarter}`)
    .then(response => {
      this.setState({reviewed: response.data})
    });
  }

  getSections = async() => {
    await axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true')
    .then(response => {
      this.setState({ sections: response.data });
    });
  }

  getSectionStudents(sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sectionStudents?filter[where][active]=true&filter[include]=student&filter[where][sectionId]='+sectionId)
    .then(response => {
      const sorted = _.sortBy(response.data, function(o){return [o.student.lastName, o.student.firstName]})
      this.setState({ sectionStudents: sorted });
    });
  }

  handleApprovalOpen = () => {
    this.setState({
      open: true
    })
  }

  handleApprovalClose = () => this.setState({
    open: false
  })

  handleOpen = (sectionId, sectionStudentId) => {
    this.getClassRemark(sectionId, sectionStudentId)

    this.setState({
      modalOpen: true,
      sectionStudentId: sectionStudentId
    })
  }

  handleClose = () => {
    this.setState({
      modalOpen: false,
      sectionStudentId: ''
    })
  }

  handleSort(clickedColumn) {
    const { column, sectionStudents, direction } = this.state
    if (column !== clickedColumn) {
      if(clickedColumn === 'name') {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, function(o){return o.student.lastName}),
          direction: 'ascending',
        })
        return
      } else {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, [clickedColumn]),
          direction: 'ascending',
        })
        return
      }
    }
    this.setState({
      sectionStudents: sectionStudents.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handleInputChange = (e, { name, value }) => {
    this.setState({[name]: value})
  }

  handleUpdateSectionDetails(data, id) {
    const url = process.env.REACT_APP_URL+'/sectionDetails/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {
        this.setState({open: false}, this.getSection(this.state.sectionId))

      })
      .catch(err => console.log(err));
  }

  handleSubmit = (sectionId, sectionStudentId) => {

    // Validations
    console.log(sectionId)
    const {remarks1, remarks2, remarks3, remarks4} = this.state;
    const data = {
      sectionStudentId: sectionStudentId,
      sectionId: sectionId,
      firstQuarter: remarks1,
      secondQuarter: remarks2,
      thirdQuarter: remarks3,
      fourthQuarter: remarks4
    }
    // Submit
    const url = process.env.REACT_APP_URL+'/classRemarks/upsertWithWhere?where={"sectionId":"'+sectionId+'","sectionStudentId":"'+sectionStudentId+'"}';
    axios
      .request({
        method: 'post',
        url: url,
        data: data
      })
      .then(response => {
        console.log(response.data)
        alert('Data has been saved.')
      })
      .catch(err => console.log(err));

  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'Class Conduct'});

    const sectionId = this.props.match.params.sectionId;
    const params = new URLSearchParams(this.props.location.search);
    const quarter = params.get('quarter');
    this.setState({quarter: quarter, sectionId: sectionId}, () => {
      this.getSectionStudents(sectionId);
      this.getSection(sectionId);
    })

  }

  componentWillReceiveProps(newProps) {

    const sectionId = newProps.match.params.sectionId;
    const params = new URLSearchParams(newProps.location.search);
    const quarter = params.get('quarter');
    this.setState({quarter: quarter, sectionId: sectionId}, () => {
      this.getSectionStudents(sectionId);
      this.getSection(sectionId);
    })

  }

  render() {
    return (
      <ClassRemarksPV
        auth={this.props.auth}
        username={this.props.username}
        userType={this.props.userType}
        userId={this.props.userId}
        column={this.state.column}
        direction={this.state.direction}
        section={this.state.section}
        quarter={this.state.quarter}
        sectionStudents={this.state.sectionStudents}
        modalOpen={this.state.modalOpen}
        open={this.state.open}
        sectionSubjects={this.state.sectionSubjects}
        sectionStudentId={this.state.sectionStudentId}
        dirtyInput={this.state.dirtyInput}
        remarks1={this.state.remarks1}
        remarks2={this.state.remarks2}
        remarks3={this.state.remarks3}
        remarks4={this.state.remarks4}
        created={this.state.created}
        checked={this.state.checked}
        reviewed={this.state.reviewed}
        sections={this.state.sections}
        handleApprovalOpen={this.handleApprovalOpen}
        handleApprovalClose={this.handleApprovalClose}
        handleOpen={this.handleOpen}
        handleClose={this.handleClose}
        handleSort={this.handleSort}
        handleInputChange={this.handleInputChange}
        handleSubmit={this.handleSubmit}
        handleUpdateSectionDetails={this.handleUpdateSectionDetails}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    username: state.AuthR.username,
    userType: state.AuthR.userType,
    userId: state.AuthR.userId
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassRemarksPC);
